import {Component, Input, OnInit} from '@angular/core';
import { OptionService } from "../option/option.service";
import {FormControl, FormGroup, Validators} from "@angular/forms";
import {Contact} from "../contact/contact";
import {GlobalValidators} from "../validate/validate.globalvalidators";
import { UrlService } from 'url/url.service';

@Component({
    selector: 'extrafield',
    templateUrl: './output.extrafield.component.html'
})
export class ExtrafieldComponent implements OnInit {
    /**
     * The current donation
     */
    @Input() contact: Contact;

    /**
     * the current step
     */
    @Input() form:FormGroup;

    /**
     * defines if the compnent is shown or not
     * @type {boolean}
     */
    showComponent:boolean = false;

    /**
     * holds the configuration from the project options
     * @type {{}}
     */
    configuration:any = {};

    /**
     * is the field required or not
     * @type {boolean}
     */
    required: boolean = false;

    /**
     * Constructor
     * @param optionService
     */
    constructor(private optionService: OptionService, private urlService: UrlService) {
        this.configuration = this.optionService.getOption('extra_field');
    }

    /**
     * function is called if the component is initialized
     */
    ngOnInit(): void {
        if(this.configuration != null && this.configuration.hasOwnProperty('label')) {
            // we have a valid configurtaion and are on the correct step, show the widget
            this.showComponent = true;
            this.required = this.configuration.mandatory === "1";

            // set validators
            if(this.required === true) {
                switch (this.configuration.type) {
                    case 'email':
                        this.form.addControl('extra', new FormControl('', [Validators.required, GlobalValidators.validateEmail]));
                        break;
                    default:
                        this.form.addControl('extra', new FormControl('', [Validators.required]));
                        break;
                }
            }
            else {
                // optional field, no validation
                this.form.addControl('extra', new FormControl());
            }

            this.preFillField();
        }
    }

    /**
     * Eventhandler when the extra field is a checkbox and the checkbox is clicked.
     * @param event
     */
    changeCheckbox(event): void {
        if(event.target.checked) {
            this.contact.data.extra = "1";
        }
        else {
            this.contact.data.extra = "";
        }
        this.form.controls['extra'].setValue(this.contact.data.extra);
        this.form.controls['extra'].updateValueAndValidity({onlySelf: true});
    }

    /**
     * Prefills the extra field with a value from the URL
     */
    preFillField(): void {
        const value = this.urlService.findGetParameter('tw_extra');
        const type = this.configuration.type;

        if (value !== null) {
            switch (type) {
                // check the checkbox if the parameter is set to 1
                case 'checkbox':
                    if (value === '1') {
                        this.contact.data.extra = '1';
                        this.form.controls['extra'].setValue(true);
                    }
                    break;
                // all other types (text, email)
                default:
                    this.contact.data.extra = value;
                    this.form.controls['extra'].setValue(this.contact.data.extra);
                    break;
            }
        }
    }
}
